export enum alerteTypes {
    LOADING = "LOADING",
    SELECTED_ALERTE = "SELECTED_ALERTE",
    GET_ALERTE_LIST = "GET_ALERTE_LIST",
    GET_ALERTE_NUMBER = "GET_ALERTE_NUMBER",
}
  
export default alerteTypes;